var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('layout',[(_vm.requirements?.data?.iwize?.iframe_url)?_c('v-card',{staticClass:"iwizeform",attrs:{"elevation":"3"}},[_c('div',{staticClass:"iwizeform-iframewrapper"},[_c('iframe',{staticClass:"iwizeform-iframe",attrs:{"src":_vm.requirements.data.iwize.iframe_url}})])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }